import type { PreviousPageState } from './notesFeature.types'

export function getBackButtonLabelForOrigin(
  previousPage: PreviousPageState,
): string {
  const path = previousPage.path ?? ''
  if (path.includes('/perio') || path.endsWith('perio')) return 'Back to perio'
  if (path.includes('/history')) return 'Back to tx plan history'
  if (path.includes('treatment-plan')) return 'Back to tx plan'
  if (path.startsWith('/charting')) return 'Back to Charting'
  if (path === '/message') {
    if (previousPage.tab === 'calls') return 'Back to calls'
    if (previousPage.tab === 'contact') return 'Back to contact'
    return 'Back to Message'
  }
  if (path === '/image-viewer') return 'Back to Image viewer'
  if (path === '/image-xrayviewer') return 'Back to X-ray viewer'
  if (path === '/appointment') return 'Back to appointment'
  if (path === '/patient-management') return 'Back to Patient management'
  if (path === '/notes') return 'Back to Notes'
  return 'Back'
}
